import reduce from 'lodash/reduce';
import some from 'lodash/some';
import {useSelector} from 'react-redux';

import {CurrentUserSelector} from 'app/current-user/api';

import {CommentReactionsType, CommentReactionType} from 'sweet-types';

type HasReactionMapType = {[reaction in CommentReactionType]: boolean};

function getUserReactedMap(
  reactions: CommentReactionsType,
  currentUserId: number
): HasReactionMapType {
  return reduce(
    reactions,
    (map, usersReactions, reaction) => {
      map[reaction] = some(usersReactions, ({id}) => id === currentUserId);
      return map;
    },
    {} as HasReactionMapType
  );
}

export function useUserReactedMap(
  reactions: CommentReactionsType
): HasReactionMapType {
  const currentUserId: number = useSelector(
    (state) => CurrentUserSelector(state).data!.id
  );

  return getUserReactedMap(reactions, currentUserId);
}
